import config from '../../config/config';
import { sessionAwareFetch } from './sessionAwareFetch';

const apiBase = () => `${config.apimUrl}/crm-api`;

function headers(json = true) {
  const h = {
    'Ocp-Apim-Subscription-Key': config.apimKeyCrmService,
  };
  if (json) h['Content-Type'] = 'application/json';
  return h;
}

async function parseError(response) {
  let msg = `HTTP ${response.status}`;
  try {
    const j = await response.json();
    if (j?.error) msg = j.error;
  } catch {
    // ignore
  }
  return msg;
}

function buildQuery(filters = {}) {
  const params = new URLSearchParams();
  if (filters.tradeId) params.set('tradeId', filters.tradeId);
  if (filters.statusId) params.set('statusId', filters.statusId);
  if (filters.relationshipManagerId) {
    params.set('relationshipManagerId', filters.relationshipManagerId);
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const outreachCrmService = {
  async getSettings() {
    const response = await sessionAwareFetch(`${apiBase()}/settings`, {
      method: 'GET',
      headers: headers(false),
      credentials: 'include',
    });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async putSettings(body) {
    const response = await sessionAwareFetch(`${apiBase()}/settings`, {
      method: 'PUT',
      headers: headers(),
      credentials: 'include',
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async getSummary(filters = {}) {
    const response = await sessionAwareFetch(
      `${apiBase()}/summary${buildQuery(filters)}`,
      {
        method: 'GET',
        headers: headers(false),
        credentials: 'include',
      },
    );
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async listProspects(filters = {}) {
    const response = await sessionAwareFetch(
      `${apiBase()}/prospects${buildQuery(filters)}`,
      {
        method: 'GET',
        headers: headers(false),
        credentials: 'include',
      },
    );
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async createProspect(body) {
    const response = await sessionAwareFetch(`${apiBase()}/prospects`, {
      method: 'POST',
      headers: headers(),
      credentials: 'include',
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async getProspect(id) {
    const response = await sessionAwareFetch(
      `${apiBase()}/prospects/${encodeURIComponent(id)}`,
      {
        method: 'GET',
        headers: headers(false),
        credentials: 'include',
      },
    );
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async patchProspect(id, body) {
    const response = await sessionAwareFetch(
      `${apiBase()}/prospects/${encodeURIComponent(id)}`,
      {
        method: 'PATCH',
        headers: headers(),
        credentials: 'include',
        body: JSON.stringify(body),
      },
    );
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async deleteProspect(id) {
    const response = await sessionAwareFetch(
      `${apiBase()}/prospects/${encodeURIComponent(id)}`,
      {
        method: 'DELETE',
        headers: headers(false),
        credentials: 'include',
      },
    );
    if (!response.ok && response.status !== 204) {
      throw new Error(await parseError(response));
    }
  },
};
